(() => {
  const init = () => {
    document.querySelectorAll('.al-discovery-v2:not([data-motion-ready])').forEach(section => {
      section.dataset.motionReady = 'true';
      if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting) { section.classList.add('is-seen'); observer.disconnect(); } });
      }, {threshold: .2});
      observer.observe(section);
    });
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',init);
})();

/* Aroma sliders: every [data-al-swiper] element runs on the theme's bundled Swiper (FoxTheme.Swiper). */
(() => {
  const presets = {
    combo: {
      spaceBetween: 16,
      slidesOffsetAfter: 36,
      breakpoints: { 750: { spaceBetween: 20, slidesOffsetAfter: 72 }, 1100: { spaceBetween: 24, slidesOffsetAfter: 72 } },
    },
    category: {
      spaceBetween: 16,
      breakpoints: { 1001: { slidesPerView: 6, spaceBetween: 16 } },
    },
  };

  const initSliders = (root = document) => {
    const S = window.FoxTheme && window.FoxTheme.Swiper;
    if (!S || !S.Swiper) return false;
    root.querySelectorAll('[data-al-swiper]:not(.swiper-initialized)').forEach(el => {
      const scope = el.closest('section') || document;
      const prev = scope.querySelector('[data-al-swiper-prev]');
      const next = scope.querySelector('[data-al-swiper-next]');
      const options = Object.assign({
        modules: [S.Navigation, S.Keyboard, S.Mousewheel, S.A11y].filter(Boolean),
        slidesPerView: 'auto',
        spaceBetween: 16,
        grabCursor: true,
        watchOverflow: true,
        threshold: 4,
        mousewheel: { forceToAxis: true },
        keyboard: { enabled: true, onlyInViewport: true },
      }, presets[el.dataset.alSwiper] || {});
      if (prev && next) options.navigation = { prevEl: prev, nextEl: next };
      el.alSwiper = new S.Swiper(el, options);
    });
    return true;
  };

  const start = () => { if (!initSliders()) window.addEventListener('load', () => initSliders(), { once: true }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', event => initSliders(event.target));
})();
